import { createReducer, on } from '@ngrx/store';
import { setGlobalServiceData } from 'src/app/STORE/actions/globalservice.actions';

export const initialState: any = {};

export const globalServiceReducer = createReducer(
  initialState,
  on(setGlobalServiceData, (state, action) => {
    return { ...state, ...action.data };
  })
);
